import { reportFeatureFlagsToAdobeDataLayer } from '@analytics/adobe';

export const useReportAdobeFeatureFlags = () => {
  return (featureFlags: { [key: string]: boolean | string }): void => {
    reportFeatureFlagsToAdobeDataLayer(featureFlags);
  };
};
